var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReturns = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  "aria-hidden": "true"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  fillRule: "evenodd",
  d: "M23.5 26.5 22.064 28 18 24l4-4 1.5 1.5-1.801 1.5H32v9H12V15.605L15 12h14l3 3.605V21h-2v-3H14v12h16v-5h-8.301zM21 14h-5l-1.5 2H21zm7 0h-5v2h6.5z"
})));
export default SvgReturns;